<template>
    <el-tooltip :content="volumeOn
        ? $t('chat.turnVolumeOff')
        : $t('chat.turnVolumeOn')
      " class="item" effect="dark" placement="top">
      <el-button class="e-volume" type="ghost" @click="toggleVolume">
        <template v-if="volumeOn">
          <icon-volume-on class="e-volume__icon" role="presentation" />
        </template>
        <template v-else>
          <icon-volume-off class="e-volume__icon" role="presentation" />
        </template>
      </el-button>
    </el-tooltip>
  </template>
  <script>
  import IconVolumeOn from 'assets/icons/volume-2.svg'
  import IconVolumeOff from 'assets/icons/volume-x.svg'
  import { mapGetters, mapActions } from 'vuex'
  export default {
    name: 'VolumeButton',
    components: {
      IconVolumeOn,
      IconVolumeOff
    },
    data () {
      return {
        internalOn: false
      }
    },
    computed: {
      ...mapGetters(['volumeOn'])
    },
    methods: {
      ...mapActions(['toggleVolume']),
    },
  }
  </script>
  <style lang="scss" scoped>
  @import './_assets/VolumeButton.scss'
  </style>